// extracted by css-extract-rspack-plugin
export default {"codeContainer":"u9Se6"};